import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import PlaidLink from './PlaidLink';

const styles = ({ palette }) => ({
  link: {
    color: palette.mycc.link,
    cursor: 'pointer',
  },
});

const VALID_STATUS = ['completed', 'verified'];

const BankAction = props => {
  const { bank, limited, classes } = props;
  const { onAccounts, onSuccess, onExit, setSelected } = props;
  let link = null;

  if (VALID_STATUS.includes(bank.status) && !limited) {
    link = (
      <Link
        underline="none"
        className={classes.link}
        onClick={() => onAccounts(bank)}
      >
        Add account from this bank
      </Link>
    );
  }
  if (bank.status === 'pending_manual' && bank.token) {
    link = (
      <PlaidLink
        underline="none"
        bank={bank}
        setSelected={setSelected}
        className={classes.link}
        onSuccess={onSuccess}
        onExit={onExit}
        token={bank.token}
      />
    );
  }

  return link;
};

export default withStyles(styles)(BankAction);
